import * as $ from 'jquery';
import 'bootstrap';
import {bookingFormCommon} from './c005-bookingform-common';
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";
import { wcagOptions } from "./wcag";
import 'selectize';
import 'datepicker';

export class viewBookingForm{
	private wcag = new wcagOptions();
	private $viewBookingError:Array<string> = [];
	private bcommon = new bookingFormCommon();
	private sourceOndList: any= [];
	private destOndList: any= [];

	$scope: any = $('#view-booking--container');
	$scopeMob: any = $('#mob-viewbooking--container');
    $scopeMobipad: any = $('#view-booking--container');
	nav(): void {
		let _self = this;
		let bcommon = _self.bcommon;
        let $scopeCheckinMob: any = $('#mob-checkin--container');
		let $mabHeader:any  = $('#mab-header');
		let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');

		let $bookFlight  : any = $('#book-flight--container');
		let $checkIn     : any = $('#check-in--container');
		let $flightStatus: any = $('#flight-status--container');
		let $mhStay      : any = $('#ibe-stay--container');
		let $mhUpgrade   : any = $('#mhupgrade-in--container');
		let $login       : any = $('#login-container');
		let $loggedin    :any = $('#logged-in-user-menu');
		let $mholidays: any 	 = $('#mholiday-ibe--container');
		let $flightUpgrade : any = $('#view-upgrade');
		let $inFlightMenu : any = $('#in-flight-menu--container');

		let $bookFlightMob  : any = $('#mobile-bookflight--container');
		let $checkInMob     : any = $('#mob-checkin--container');
		let $flightStatusMob: any = $('#mob-flightstatus--container');
		let $mhStayMob      : any = $('#mob-stay--container');
		let $mhUpgradeMob   : any = $('#mob-mhupgrade--container');
		let $mobMholidays  : any = $('#mobile-mholidays--container');
		let $loginMob       : any = $('#mob-login--container');
		let $loggedinMob    : any = $('#mob-logged-in-user-menu');
		let $flightupgradeMob: any 	 = $('#mob-flightupgrade--container');
		let $ibeNav    : any;
		if($('.ibe-refresh').length >0) {
			$ibeNav = $('.desktop #bookingNav');
		}
		else {
			$ibeNav = $('#bookingNav');
		}
		let $ibeNavList: any = $('#bookingNav li');
		let $moreLinks: any 	 = $('#more-links--container');
		let $moreLinksMob: any 	 = $('#mob-more-links--container');
		let $moreLinksManage: any 	 = $('#more-links--container .manage-booking');
		let $enrichHotel:any         = $('#enrich-hotels-container');
		let $enrichHotelMob:any      = $('#mob-enrich-hotels-container');		

		let $navOverlay        : any = $('.mab-nav--overlay');
		let $errorValidationGen:any = $('.viewbooking-error--validation');
		let $bookingFormTitle  :any = $('.booking-form--title');
		let $inputValidator    :any = $('.form-validate input');
		let $nameValidatorGen:any       = $('.name-validator');
		let $numValidatorGen:any        = $('.num-validator');
		let $couponCodeGen:any          = $('.couponCode');
		let $redemptionLogin:any        = $('.redemption-login .form-group');

		let $cugParam: any = $('#search-param-cug').val();
		if ($cugParam == "CUG") {
			$navOverlay.find('.mobile-mholiday').parent().hide();
			$navOverlay.find('.mobile-check-in').parent().hide();
			$navOverlay.find('.mobile-flight-status').parent().hide();
			$navOverlay.find('.mobile-enrich-login').parent().hide();
			let mobbookOptViewBookTab = $navOverlay.find('.mobile-view-booking');
			mobbookOptViewBookTab.html(mobbookOptViewBookTab.html().replace(mobbookOptViewBookTab.text(), $ibeNav.find('.view-booking').text()));
		}
		// IBE Navigation show/hide Check in container
		$ibeNav.find('.view-booking').on('click', () =>{
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:top-nav-manage',
                'componentType': 'tab',
                'componentName': 'Manage Top Menu',
                'componentID': '',
				'attributes': []
            });
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.view-booking').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
			}
			_self.$scope.show();
			$bookFlight.hide();
			$checkIn.hide();
			$flightStatus.hide();
			$flightUpgrade.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$inFlightMenu.hide();
			$login.hide();
			$moreLinks.hide();
			$loggedin.addClass('hidden');
			$mholidays.hide();
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$enrichHotel.hide();
			$enrichHotelMob.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');
			$bookingFormTitle.removeClass('has-error');
			$nameValidatorGen.removeClass('has-error');
			$numValidatorGen.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
			
			if (_self.$scope.find('.book-opt-car').parent().hasClass('selected')) {
				_self.$scope.find('#mhupgrade-in--container').hide();
				_self.$scope.find('.mh-upgrade--containertab').show();
				_self.$scope.find('.view-booking--containertab').hide();
				_self.$scope.find('#view-nfs--container').hide();
				_self.$scope.find('#ibe-stay--container').show();
				_self.$scope.css('padding-bottom', '0px');
			} else if (_self.$scope.find('.book-opt-viewbooking').parent().hasClass('selected')) {
				_self.$scope.find('#mhupgrade-in--container').hide();
				_self.$scope.find('.mh-upgrade--containertab').hide();
				_self.$scope.find('.view-booking--containertab').show();
				_self.$scope.find('#view-nfs--container').hide();
				_self.$scope.find('#ibe-stay--container').hide();
				_self.$scope.css('padding-bottom', '20px');
			}
			else if (_self.$scope.find('.book-opt-nfs').parent().hasClass('selected')) {
				_self.$scope.find('#mhupgrade-in--container').hide();
				_self.$scope.find('.mh-upgrade--containertab').show();
				_self.$scope.find('.view-booking--containertab').hide();
				_self.$scope.find('#view-nfs--container').show();
				_self.$scope.find('#ibe-stay--container').hide();
				_self.$scope.css('padding-bottom', '20px');
			}
			else if(_self.$scope.find('.inflight-menu').parent().hasClass('selected')) {
				_self.$scope.find('#view-nfs--container').hide();
				_self.$scope.find('.view-booking--containertab').hide();
				_self.$scope.find('.mh-upgrade--containertab').show();
				_self.$scope.find('#mhupgrade-in--container').hide();
				_self.$scope.find('#ibe-stay--container').hide();
				_self.$scope.find('#in-flight-menu--container').show();
				_self.$scope.css('padding-bottom', '20px');
			}
			else {
				_self.$scope.find('#view-nfs--container').hide();
				_self.$scope.find('.view-booking--containertab').hide();
				_self.$scope.find('.mh-upgrade--containertab').show();
				_self.$scope.find('#mhupgrade-in--container').show();
				_self.$scope.find('#ibe-stay--container').hide();
				_self.$scope.css('padding-bottom', '20px');
			}			

			if ($cugParam == "CUG") {
				_self.$scope.find('#mhupgrade-in--container').hide();
				_self.$scope.find('.mh-upgrade--containertab').hide();
				_self.$scope.find('.view-booking--containertab').show();
				_self.$scope.find('#view-nfs--container').hide();
				_self.$scope.find('#ibe-stay--container').hide();
				_self.$scope.css('padding-bottom', '20px');
			}
		});

		$moreLinksManage.on('click', () =>{
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.view-booking').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
			}
			_self.$scope.show();
			$bookFlight.hide();
			$checkIn.hide();
			$flightStatus.hide();
			$flightUpgrade.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$inFlightMenu.hide();
			$login.hide();
			$moreLinks.hide();
			$loggedin.addClass('hidden');
			$mholidays.hide();
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');
			$bookingFormTitle.removeClass('has-error');
			$nameValidatorGen.removeClass('has-error');
			$numValidatorGen.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
			
			if (_self.$scope.find('.book-opt-car').parent().hasClass('selected')) {
				_self.$scope.find('#mhupgrade-in--container').hide();
				_self.$scope.find('.mh-upgrade--containertab').show();
				_self.$scope.find('.view-booking--containertab').hide();
				_self.$scope.find('#view-nfs--container').hide();
				_self.$scope.find('#ibe-stay--container').show();
				_self.$scope.css('padding-bottom', '0px');
			} else if (_self.$scope.find('.book-opt-viewbooking').parent().hasClass('selected')) {
				_self.$scope.find('#mhupgrade-in--container').hide();
				_self.$scope.find('.mh-upgrade--containertab').hide();
				_self.$scope.find('.view-booking--containertab').show();
				_self.$scope.find('#view-nfs--container').hide();
				_self.$scope.find('#ibe-stay--container').hide();
				_self.$scope.css('padding-bottom', '20px');
			}
			else if (_self.$scope.find('.book-opt-nfs').parent().hasClass('selected')) {
				_self.$scope.find('#mhupgrade-in--container').hide();
				_self.$scope.find('.mh-upgrade--containertab').show();
				_self.$scope.find('.view-booking--containertab').hide();
				_self.$scope.find('#view-nfs--container').show();
				_self.$scope.find('#ibe-stay--container').hide();
				_self.$scope.css('padding-bottom', '20px');
			}
			else if(_self.$scope.find('.inflight-menu').parent().hasClass('selected')) {
				_self.$scope.find('#view-nfs--container').hide();
				_self.$scope.find('.view-booking--containertab').hide();
				_self.$scope.find('.mh-upgrade--containertab').hide();
				_self.$scope.find('#mhupgrade-in--container').show();
				_self.$scope.find('#ibe-stay--container').hide();
				_self.$scope.find('#in-flight-menu--container').show();
				_self.$scope.css('padding-bottom', '20px');
			}
			else {
				_self.$scope.find('#view-nfs--container').hide();
				_self.$scope.find('.view-booking--containertab').hide();
				_self.$scope.find('.mh-upgrade--containertab').show();
				_self.$scope.find('#mhupgrade-in--container').show();
				_self.$scope.find('#ibe-stay--container').hide();
				_self.$scope.css('padding-bottom', '20px');
			}			

			if ($cugParam == "CUG") {
				_self.$scope.find('#mhupgrade-in--container').hide();
				_self.$scope.find('.mh-upgrade--containertab').hide();
				_self.$scope.find('.view-booking--containertab').show();
				_self.$scope.find('#view-nfs--container').hide();
				_self.$scope.find('#ibe-stay--container').hide();
				_self.$scope.css('padding-bottom', '20px');
			}
		});


		// IBE Navigation show/hide Mobile View booking container
		$('.mobile-view-booking').on('click', () =>{
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:top-nav-manage',
                'componentType': 'tab',
                'componentName': 'Manage Top Menu',
                'componentID': '',
				'attributes': []
            });
			$ibeNavList.removeClass('selected');
			$('.mobile-view-booking').parent().addClass('selected');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$inFlightMenu.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$mobMholidays.hide();
			$flightupgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$moreLinksMob.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');
			bcommon.scrollToTopIBE();	
			let mobbookOptViewBookTab = _self.$scopeMob.find('.book-opt-viewbooking');
			mobbookOptViewBookTab.trigger('click');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header').addClass('hide');	
				$('.enrich-revamp .enrich-mobile-ibe-container').removeClass('hide');			
				let targetHeight: any = $(window).innerHeight() + 'px';
				$('.enrich-revamp #mob-viewbooking--container').css('height', targetHeight);					
			}	
		});

		// Overlay container - IBE Navigation show/hide Mobile Check in container
		$navOverlay.find('.mobile-view-booking').on('click', () =>{
			$ibeNavList.removeClass('selected');
			$mobIbeNav.find('.mobile-view-booking').parent().addClass('selected');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$flightupgradeMob.hide();
			$mobMholidays.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');
			bcommon.scrollToTopIBE();
			let mobbookOptViewBookTab = _self.$scopeMob.find('.book-opt-viewbooking');
			mobbookOptViewBookTab.trigger('click');
			// $scopeCheckinMob.find("input[name='mob_book_opt']").filter('[value=manage_booking]').prop('checked', true);
			// $scopeCheckinMob.find('.mob-check-in--containertab').hide();
			// $scopeCheckinMob.find('.mob-view-booking--containertab').show();
			// $scopeCheckinMob.find('#mob-nfs--container').hide();	
			if (window.innerWidth > 767 && window.innerWidth < 1200) {
				$ibeNav.find('li').removeClass('selected');
				$ibeNav.find('.view-booking').parent().addClass('selected');
				let $viewBookingMob: any = $('#mob-viewbooking--container');
				let $viewBooking: any = $('#view-booking--container');
				let $mhStay: any = $('#ibe-stay--container');
				let $mhUpgrade: any = $('#mhupgrade-in--container');
				let $mobMholidays: any = $('#mobile-mholidays--container');
				let $mhHolidays: any = $('#mholiday-ibe--container');
				let $bookingFormTitle: any = $('.booking-form--title');
				let $nameValidatorGen: any = $('.name-validator');
				let $numValidatorGen: any = $('.num-validator');
				let $couponCodeGen: any = $('.couponCode');
				let $redemptionLogin: any = $('.redemption-login .form-group');
				let $checkInRefSel: any = $('.checkin-refno--departure');
				let $checkeTicketSel: any = $('.checkin-eticket--departure');
				let $checkInRefSelectize: any = $checkInRefSel.parent().find('.selectize-control .selectize-input');
				let $checkeTicketSelectize: any = $checkeTicketSel.parent().find('.selectize-control .selectize-input');
				let $errorValidationEticketGen: any = $('.checkin-eticketnos--error---validation');
				$bookFlight.hide();
				$flightStatus.hide();
				$mhStay.hide();
				$mhUpgrade.hide();
				$login.hide();
				$mhHolidays.hide();
				$loggedin.addClass('hidden');
				_self.$scopeMobipad.show();
				$bookFlightMob.hide();
				$viewBookingMob.hide();
				$flightStatusMob.hide();
				$checkIn.hide();
				$checkInMob.hide();
				$mhStayMob.hide();
				$mhUpgradeMob.hide();
				$loginMob.hide();
				$loggedinMob.hide();
				$errorValidationGen.hide();
				$errorValidationEticketGen.hide();
				$bookingFormTitle.removeClass('has-error');
				$nameValidatorGen.removeClass('has-error');
				$numValidatorGen.removeClass('has-error');
				$couponCodeGen.removeClass('has-error');
				$redemptionLogin.removeClass('has-error');
				$checkInRefSelectize.removeClass('has-error');
				$checkeTicketSelectize.removeClass('has-error');
				// let bookOptionVal=_self.$scopeMobipad.find("input[name='book_opt']").filter('[value=manage_booking]').prop('checked', true);

				// 	if(bookOptionVal == 'check_in'){
				// 		_self.$scopeMobipad.find('#view-booking--container').hide();
				// 		_self.$scopeMobipad.find('.view-booking--containertab').hide();
				// 		_self.$scopeMobipad.find('.check-in--containertab').show();
				// 		_self.$scopeMobipad.find('#view-nfs--container').hide();	
				// 	}else{
				// 		_self.$scopeMobipad.find('.check-in--containertab').hide();
				// 		_self.$scopeMobipad.find('.view-booking--containertab').show();
				// 		_self.$scopeMobipad.find('#view-booking--container').show();
				// 		_self.$scopeMobipad.find('#view-nfs--container').hide();	
				// 	}

			}
		});
	}

	post_to_url(path:string, params:any): void {
		var method = "post";
		var form = document.createElement("form");
		form.setAttribute("method", method);
		form.setAttribute("action", path);

		for(var key in params) {
			if(params.hasOwnProperty(key)) {
				var hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
				form.appendChild(hiddenField);
			}
		}
		document.body.appendChild(form);
		form.submit();
	}

	getUrlVars(url:string): any {
		var vars:any = [], hash:any;
		var hashes = url.slice(url.indexOf('?') + 1).split('&');
		for(var i = 0; i < hashes.length; i++)
		{
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}

	viewbookingForm(): void {
		let _self = this;

		let $vbErrorValidation: any = _self.$scope.find('.view-booking--containertab .viewbooking-error--validation');
		let $vbValidator : any = _self.$scope.find('.view-booking--containertab .viewbooking-validator');
		let $vbSubmitBtn: any = _self.$scope.find('.view-booking--containertab .viewBooking');
		let $vbRefNo: any = _self.$scope.find('.view-booking--containertab .view-booking--refno');
		let $vbLastName: any = _self.$scope.find('.view-booking--containertab .view-booking--lastname');

		let $mobVBErrorValidation: any = _self.$scopeMob.find('.mob-view-booking--containertab .viewbooking-error--validation');
		let $mobVBValidator : any = _self.$scopeMob.find('.mob-view-booking--containertab .viewbooking-validator');
		let $mobVBSubmitBtn: any = _self.$scopeMob.find('.mob-view-booking--containertab .viewBooking');
		let $mobVBRefNo: any = _self.$scopeMob.find('.mob-view-booking--containertab .view-booking--refno');
		let $mobVBLastName: any = _self.$scopeMob.find('.mob-view-booking--containertab .view-booking--lastname');

		/** desktop manage booking submit handler */
		$vbSubmitBtn.click((evt:any) => {
			evt.preventDefault();
			adobeDataLayer.push('click', {
                'clickName': 'click:btn-click:manage-manage-booking',
                'componentType': 'btn',
                'componentName': 'Manage Booking Submit',
                'componentID': '',
				'attributes': []
            });
			let $validationSuccess    : any = true;
			_self.$viewBookingError = [];
			$vbErrorValidation.show();
			/** validate View Booking Ref No. */
			if($vbRefNo.val() == ''){
				let $vbRefNoValidate:any = $vbRefNo.attr('data-eticketno');
				_self.$viewBookingError.push('<strong>'+$vbRefNo.parent().find('label').text()+':</strong> '+$vbRefNoValidate);
				$vbRefNo.addClass('has-error');
				$vbRefNo.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else{
				$vbRefNo.removeClass('has-error');
				$vbRefNo.parent().find('.booking-form--title').removeClass('has-error');
			}

			/** validate Last Name */
			if($vbLastName.val() == ''){
				let $vbLastNameValidate:any = $vbLastName.attr('data-lastname');
				_self.$viewBookingError.push('<strong>'+$vbLastName.parent().find('label').text()+':</strong> '+$vbLastNameValidate);
				$vbLastName.addClass('has-error');
				$vbLastName.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else{
				$vbLastName.removeClass('has-error');
				$vbLastName.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = $vbValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$viewBookingError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$viewBookingError[i] + '</li>');
			}

			if($validationSuccess) {
				$vbErrorValidation.hide();
        _self.errorStatus($vbRefNo, $vbLastName,'desktop');
			}
		});

		/** Mobile -  manage booking submit handler */
		$mobVBSubmitBtn.click((evt:any) => {
			evt.preventDefault();
			let $validationSuccess    : any = true;
			_self.$viewBookingError = [];
			$mobVBErrorValidation.show();

			/** validate View Booking Ref No. */
			if($mobVBRefNo.val() == ''){
				let $mobVbRefNoValidate:any = $mobVBRefNo.attr('data-eticketno');
				_self.$viewBookingError.push('<strong>'+$mobVBRefNo.parent().find('label').text()+':</strong> '+$mobVbRefNoValidate);
				$mobVBRefNo.addClass('has-error');
				$mobVBRefNo.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else{
				$mobVBRefNo.removeClass('has-error');
				$mobVBRefNo.parent().find('.booking-form--title').removeClass('has-error');
			}

			/** validate Last Name */
			if($mobVBLastName.val() == ''){
				let $mobVBLastNameValidate:any = $mobVBLastName.attr('data-lastname');
				_self.$viewBookingError.push('<strong>'+$mobVBLastName.parent().find('label').text()+':</strong> '+$mobVBLastNameValidate);
				$mobVBLastName.addClass('has-error');
				$mobVBLastName.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else{
				$mobVBLastName.removeClass('has-error');
				$mobVBLastName.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = $mobVBValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$viewBookingError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$viewBookingError[i] + '</li>');
			}

			if($validationSuccess) {
				$mobVBErrorValidation.hide();
				_self.errorStatus($mobVBRefNo, $mobVBLastName,'mobile');
			}
		});
	}

  /**
	 * validate both input fields in form for empty state
	 *
	 * if both not empty, hide error message div
	 * else do nothing
	 * @param {any} valEl    [error messages div]
	 * @param {any} refNo    [booking reference input]
	 * @param {any} lastName [last name input]
	 */
	validateEmptyInput(valEl:any, refNo:any, lastName:any): boolean {
  	let _self = this;
		if (refNo.val() != '' && lastName.val() != '') {
			valEl.hide();
			return false;
		}
		else {
			return true;
		}
	}

  /**
   * validate booking reference no
   *
   * if error found:
   * - add 'has-error' class to input and label
   * - append error message to error array obj
   * else:
   * - remove 'has-error' class from input and label
   * @param {any} refNo [booking reference input]
   */
  validateRefNo(refNo:any): boolean {
  	let _self = this;
  	if (refNo.val() == '') {
  		refNo.addClass('has-error');
  		refNo.parent().find('.booking-form--title').addClass('has-error');
  		var validateTicket = refNo.attr('data-eticketno');
  		_self.$viewBookingError.push(validateTicket);
  		return false;
  	}
  	else {
  		refNo.removeClass('has-error');
  		refNo.parent().find('.booking-form--title').removeClass('has-error');
  		return true;
  	}
  }

  /**
   * validate last name
   *
   * if error found:
   * - add 'has-error' class to input and label
   * - append error message to error array obj
   * else:
   * - remove 'has-error' class from input and label
   * @param {any} refNo [last name input]
   */
  validateLastName(lastName:any): boolean {
  	let _self = this;
  	if (lastName.val() == '') {
  		lastName.addClass('has-error');
  		lastName.parent().find('.booking-form--title').addClass('has-error');
  		var validateLastName_1 = lastName.attr('data-lastname');
  		_self.$viewBookingError.push(validateLastName_1);
  		return false;
  	}
  	else {
  		lastName.removeClass('has-error');
  		lastName.parent().find('.booking-form--title').removeClass('has-error');
  		return true;
  	}
  }

  /**
   * consolidate error messages in error array obj to string
   * and print to error message element
   * @param {any} errorEl [error message element]
   */
  errConsolidate(errorEl:any): void {
  	let _self = this;
  	errorEl.text(_self.$viewBookingError.join(', '));
  	return;
  }

  /**
   * return error status in console
   * - for debug only
   * @param {any} refNo    [booking reference input]
   * @param {any} lastName [last name input]
   */
  errorStatus(refNo:any, lastName:any, device:string): boolean {
  	let _self = this;
  	var bcommon = _self.bcommon;
  	var $data:any = {};
  	bcommon.preloader();
  	if (refNo.val() != '' && lastName.val() != '') {
  		var $eTicketNumber = refNo.val(),
  		$lastName = lastName.val();

  			var embedTrans = "RetrievePNR";
  			var embedTransLabel = "EMBEDDED_TRANSACTION";
  			var externalId = "BOOKING";
  			var site = "desktop";
  			$data = {
  				REC_LOC: $eTicketNumber,
  				DIRECT_RETRIEVE_LASTNAME: $lastName,
  				DIRECT_RETRIEVE: 'TRUE',
  				TRIP_FLOW: 'YES',
  				EMBEDDED_TRANSACTION: embedTrans,
  				EXTERNAL_ID: externalId,
  				SITE: site,
  				SO_GL: '',
  				SO_SITE_ALLOW_DIRECT_RT: 'TRUE',
  				SO_SITE_ALLOW_PNR_MODIF: 'Y',
  				SO_SITE_ALLOW_PNR_SERV: 'YES',
  				SO_SITE_ALLOW_TKT_PNR_MODIF: 'Y',
  				SO_SITE_DISPL_SPECIAL_REQS: 'TRUE',
  				SO_SITE_ETKT_VIEW_ENABLED: 'TRUE',
  				SO_SITE_OFFICE_ID: '',
  				SO_SITE_PNR_SERV_REQ_LOGIN: 'NO',
  				SO_SITE_QUEUE_OFFICE_ID: '',
  				SO_SITE_RT_PRICE_FROM_TST: 'TRUE',
  				SO_SITE_RT_SHOW_PRICES: 'TRUE',
  				VIEW_BOOKING: 'TRUE',
  				OVERRIDE_ENABLE: 'TRUE'
  			};
  		
  		console.log('Success');
		  var queryString = Object.keys($data)
		  .map(key => {
			if (key === 'DIRECT_RETRIEVE_LASTNAME') {
			  return key + encodeURIComponent('=') + $data[key];
			} else {
			  return key + encodeURIComponent('=') + encodeURIComponent($data[key]);
			}
		  })
		  .join(encodeURIComponent('&'));
		console.log(queryString)
  		var $tripFlowUrl = queryString; // $.param($data);
  		console.log("tripFlowUrl:" + $tripFlowUrl);
  		var $tripflow_encryptURL = $tripFlowUrl ; //encodeURIComponent($tripFlowUrl);
  		console.log("tripflow_encryptURL:" + $tripflow_encryptURL);

  		$.ajax({
  			type: 'POST',
  			url:'/bin/services/new/ibe',
  			data:'url='+ $tripflow_encryptURL,
  			success: function(msg:any){
  				console.log("##Successful: " + msg);

  				var json = msg;
  				console.log("##Redirect URL: "+ json.url);
  				// window.location.replace(json.url);
  				var responseUrl = json.url;
  				var redirectUrl = responseUrl.substring(0, responseUrl.indexOf('?'));
  				_self.post_to_url(redirectUrl, _self.getUrlVars(responseUrl));
  				// bcommon.preloaderClose();
  			}
  		});
  		return true;
  	}
  	else {
  		console.log('Fail');
  		bcommon.preloaderClose();
  		return false;
  	}
  }

	/**
	 * pre-populate ibe on load with data attached via data-attributes
	 * for both desktop and mobile ibe
	 * @author dominic <dominic.gan@mirumagency.com>
	 *
	 * @param {ibeViewBookingData} data
	 * @param {any}         instance
	 */
	populateOnload(data:ibeViewBookingData, instance:any): void {
		console.log('pop vwb', data, instance);

		// populate desktop & mobile ibe
		// same field classnames so same method is okay

		// booking ref
		if (data.bookRef !== undefined) {
			let bookRefInput = instance.find('.view-booking--refno');
			bookRefInput.val(decodeURI(data.bookRef)).blur();
		}

		// last name
		if (data.lastName !== undefined) {
			let lastNameInput = instance.find('.view-booking--lastname');
			lastNameInput.val(decodeURI(data.lastName)).blur();
		}
	}

	populateOnloadMHUpgrade(data:ibeMHUpgradeData, instance:any): void {
		console.log('pop mhu', data, instance);

		// populate desktop & mobile ibe
		// same field classnames so same method is okay

		// booking ref
		if (data.bookRef !== undefined) {
			let bookRefInput = instance.find('.mhupgrade-PNR');
			bookRefInput.val(decodeURI(data.bookRef)).blur();
		}

		// last name
		if (data.lastName !== undefined) {
			let lastNameInput = instance.find('.mhupgrade-lastname');
			lastNameInput.val(decodeURI(data.lastName)).blur();
		}
	}

	/**
	 * parse url params to detect view booking deep link
	 * open and populate with params
	 * ?ibe=vwb&bookRef=ABC&lastName=ABC
	 */
	deeplink():void {
		let _self = this;
		let bcommon = _self.bcommon;

		let urlParams = bcommon.getUrlVars(window.location.href);
		let hash = window.location.hash;

		if (urlParams.ibe && urlParams.ibe === 'vwb') {

			// parse url params into ibeViewBookingData object
			let vwbData:ibeViewBookingData = {};

			vwbData.bookRef = urlParams.bookRef;
			vwbData.lastName = urlParams.lastName;

			let $scopeViewBooking: any = $('#view-booking--container');
			let $scopeViewBookingMob: any = $('#mob-viewbooking--container');		
			const topNavIbe = $('.desktop#mab-bookingnav #view-booking--container');
			const mobNavIbe = $('.mobile#mab-bookingnav #mob-viewbooking--container');

			// expand desktop ibe
			if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
				let $ibeNav: any;
				if($('.ibe-refresh').length >0) {
					$ibeNav = $('.desktop #bookingNav');
				}
				else {
					$ibeNav = $('#bookingNav');
				}
				$ibeNav.find('.view-booking').click();
				let bookOptViewBookTab = _self.$scope.find('.book-opt-viewbooking');
				bookOptViewBookTab.click();
				_self.populateOnload(vwbData, topNavIbe);
			} else {
				let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');
				$mobIbeNav.find('.mobile-view-booking').click();
				let mobbookOptViewBookTab = _self.$scopeMob.find('.book-opt-viewbooking');
				mobbookOptViewBookTab.click();
				_self.populateOnload(vwbData, mobNavIbe);
			}
		}
		if (urlParams.ibe && urlParams.ibe === 'mhu') {

			// parse url params into ibeMHUpgradeData object
			let mhuData: ibeMHUpgradeData = {};

			mhuData.bookRef = urlParams.bookRef;
			mhuData.lastName = urlParams.lastName;
			
			const topNavIbe = $('.desktop#mab-bookingnav #view-booking--container');
			const mobNavIbe = $('.mobile#mab-bookingnav #mob-viewbooking--container');

			// expand desktop ibe
			if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
				let $ibeNav: any;
				if($('.ibe-refresh').length >0) {
					$ibeNav = $('.desktop #bookingNav');
				}
				else {
					$ibeNav = $('#bookingNav');
				}
				$ibeNav.find('.view-booking').click();
				let bookOptMHupgTab = _self.$scope.find('.book-opt-mhupgrade');
				bookOptMHupgTab.click();
				_self.populateOnloadMHUpgrade(mhuData, topNavIbe);
			} else {
				let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');
				$mobIbeNav.find('.mobile-view-booking').click();
				let mobbookOptMHupgTab = _self.$scopeMob.find('.book-opt-mhupgrade');
				mobbookOptMHupgTab.click();
				_self.populateOnloadMHUpgrade(mhuData, mobNavIbe);
			}
		}
		if(hash == "#inflightmenu") {
			let vwbData:ibeViewBookingData = {};
			const topNavIbe = $('.desktop#mab-bookingnav #view-booking--container');
			const mobNavIbe = $('.mobile#mab-bookingnav #mob-viewbooking--container');

			// expand desktop ibe
			if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
				let $ibeNav: any;
				if($('.ibe-refresh').length >0) {
					$ibeNav = $('.desktop #bookingNav');
				}
				else {
					$ibeNav = $('#bookingNav');
				}
				$ibeNav.find('.view-booking').click();
				_self.$scope.find('#mhupgrade-in--container').hide();
				_self.$scope.find('.mh-upgrade--containertab').show();
				_self.$scope.find('#in-flight-menu--container').show();
				_self.$scope.find('.view-booking--containertab').hide();
				_self.$scope.find('#ibe-stay--container').hide();
				_self.$scope.find('#view-nfs--container').hide();
				_self.$scope.css('padding-bottom', '20px');
				_self.$scope.find('.checkin-list li').removeClass('selected');
				_self.$scope.find('.inflight-menu').parent().addClass('selected');
			} else {
				let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');
				$mobIbeNav.find('.mobile-view-booking').click();
				_self.$scopeMob.find('#mob-mhupgrade--container').hide();
				_self.$scopeMob.find('.mob-mh-upgrade--containertab').show();
				_self.$scopeMob.find('.mob-view-booking--containertab').hide();
				_self.$scopeMob.find('#mob-nfs--container').hide();
				_self.$scopeMob.find('#mob-stay--container').hide();
				_self.$scopeMob.css('padding-bottom', '0px');
				_self.$scopeMob.find('.checkin-list li').removeClass('selected');
				_self.$scopeMob.find('.in-flight-menu').parent().addClass('selected');
				_self.$scopeMob.find('#mob-in-flight-menu--container').show();
			}
		}
	}

	init(): void {
		let _self = this;

		let $cugParam:any = $('#search-param-cug').val();

		if($cugParam == "CUG") {
			_self.$scope.find('.booking-merged-container').hide();
		}

		let bookOptViewBookTab = _self.$scope.find('.book-opt-viewbooking');
		let bookOptCarTab = _self.$scope.find('.book-opt-car');
		let bookOptMHupgTab = _self.$scope.find('.book-opt-mhupgrade');
		let bookOptNFSTab = _self.$scope.find('.book-opt-nfs');
		let inFlightMenu = _self.$scope.find('.inflight-menu');
		let mobbookOptViewBookTab = _self.$scopeMob.find('.book-opt-viewbooking');
		let mobbookOptCarTab = _self.$scopeMob.find('.book-opt-car');
		let mobbookOptMHupgTab = _self.$scopeMob.find('.book-opt-mhupgrade');
		let mobbookOptNFSTab = _self.$scopeMob.find('.book-opt-nfs');
		let mobInFlightMenu = _self.$scopeMob.find('.inflight-menu');
		

		bookOptViewBookTab.click(function () {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:manage-booking',
                'componentType': 'tab',
                'componentName': 'Manage Booking',
                'componentID': '',
				'attributes': []
            });
			_self.$scope.find('#mhupgrade-in--container').hide();
			_self.$scope.find('.mh-upgrade--containertab').hide();
			_self.$scope.find('#in-flight-menu--container').hide();
			_self.$scope.find('.view-booking--containertab').show();
			_self.$scope.find('#view-nfs--container').hide();
			_self.$scope.find('#ibe-stay--container').hide();
			_self.$scope.css('padding-bottom', '20px');
			_self.$scope.find('.checkin-list li').removeClass('selected');
			_self.$scope.find('.book-opt-viewbooking').parent().addClass('selected');
		});
		bookOptCarTab.click(function () {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:car',
                'componentType': 'tab',
                'componentName': 'Car',
                'componentID': '',
				'attributes': []
            });
			_self.$scope.find('#mhupgrade-in--container').hide();
			_self.$scope.find('.mh-upgrade--containertab').show();
			_self.$scope.find('#in-flight-menu--container').hide();
			_self.$scope.find('.view-booking--containertab').hide();
			_self.$scope.find('#view-nfs--container').hide();
			_self.$scope.find('#ibe-stay--container').show();
			_self.$scope.css('padding-bottom', '0px');
			_self.$scope.find('.checkin-list li').removeClass('selected');
			_self.$scope.find('.book-opt-car').parent().addClass('selected');
		});
		bookOptMHupgTab.click(function () {
			_self.$scope.find('.view-booking--containertab').hide();
			_self.$scope.find('.mh-upgrade--containertab').show();
			_self.$scope.find('#in-flight-menu--container').hide();
			_self.$scope.find('#ibe-stay--container').hide();
			_self.$scope.find('#view-nfs--container').hide();						
			_self.$scope.find('#mhupgrade-in--container').show();
			_self.$scope.css('padding-bottom', '20px');
			_self.$scope.find('.checkin-list li').removeClass('selected');
			_self.$scope.find('.book-opt-mhupgrade').parent().addClass('selected');
		});
		bookOptNFSTab.click(function () {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:neighbour-free-seat',
                'componentType': 'tab',
                'componentName': 'Neighbour free Seat Menu',
                'componentID': '',
				'attributes': []
            });
			_self.$scope.find('#mhupgrade-in--container').hide();
			_self.$scope.find('.mh-upgrade--containertab').show();
			_self.$scope.find('#in-flight-menu--container').hide();
			_self.$scope.find('.view-booking--containertab').hide();
			_self.$scope.find('#ibe-stay--container').hide();
			_self.$scope.find('#view-nfs--container').show();
			_self.$scope.css('padding-bottom', '20px');
			_self.$scope.find('.checkin-list li').removeClass('selected');
			_self.$scope.find('.book-opt-nfs').parent().addClass('selected');
		});
		inFlightMenu.click(function () {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:inflight-menu',
                'componentType': 'tab',
                'componentName': 'Inflight Menu',
                'componentID': '',
				'attributes': []
            });
			_self.$scope.find('#mhupgrade-in--container').hide();
			_self.$scope.find('.mh-upgrade--containertab').show();
			_self.$scope.find('#in-flight-menu--container').show();
			_self.$scope.find('.view-booking--containertab').hide();
			_self.$scope.find('#ibe-stay--container').hide();
			_self.$scope.find('#view-nfs--container').hide();
			_self.$scope.css('padding-bottom', '20px');
			_self.$scope.find('.checkin-list li').removeClass('selected');
			_self.$scope.find('.inflight-menu').parent().addClass('selected');
		});

		mobbookOptViewBookTab.click(function () {
			_self.$scopeMob.find('#mob-mhupgrade--container').hide();
			_self.$scopeMob.find('.mob-mh-upgrade--containertab').hide();
			_self.$scopeMob.find('.mob-view-booking--containertab').show();
			_self.$scopeMob.find('#mob-nfs--container').hide();
			_self.$scopeMob.find('#mob-stay--container').hide();
			_self.$scopeMob.css('padding-bottom', '20px');
			_self.$scopeMob.find('.checkin-list li').removeClass('selected');
			_self.$scopeMob.find('.book-opt-viewbooking').parent().addClass('selected');
			_self.$scopeMob.find('#mob-in-flight-menu--container').hide();
		});

		mobbookOptCarTab.click(function () {
			_self.$scopeMob.find('#mob-mhupgrade--container').hide();
			_self.$scopeMob.find('.mob-mh-upgrade--containertab').show();
			_self.$scopeMob.find('.mob-view-booking--containertab').hide();
			_self.$scopeMob.find('#mob-nfs--container').hide();
			_self.$scopeMob.find('#mob-stay--container').show();
			_self.$scopeMob.find('#mob-in-flight-menu--container').hide();
			_self.$scopeMob.css('padding-bottom', '0px');
			_self.$scopeMob.find('.checkin-list li').removeClass('selected');
			_self.$scopeMob.find('.book-opt-car').parent().addClass('selected');
		});
		mobInFlightMenu.click(function () {
			_self.$scopeMob.find('#mob-mhupgrade--container').hide();
			_self.$scopeMob.find('.mob-mh-upgrade--containertab').show();
			_self.$scopeMob.find('.mob-view-booking--containertab').hide();
			_self.$scopeMob.find('#mob-nfs--container').hide();
			_self.$scopeMob.find('#mob-stay--container').hide();
			_self.$scopeMob.css('padding-bottom', '0px');
			_self.$scopeMob.find('.checkin-list li').removeClass('selected');
			_self.$scopeMob.find('.inflight-menu').parent().addClass('selected');
			_self.$scopeMob.find('#mob-in-flight-menu--container').show();
		});

		mobbookOptMHupgTab.click(function () {
			_self.$scopeMob.find('.mob-view-booking--containertab').hide();
			_self.$scopeMob.find('.mob-mh-upgrade--containertab').show();
			_self.$scopeMob.find('#mob-mhupgrade--container').show();
			_self.$scopeMob.find('#mob-nfs--container').hide();
			_self.$scopeMob.find('#mob-stay--container').hide();
			_self.$scopeMob.css('padding-bottom', '20px');
			_self.$scopeMob.find('.checkin-list li').removeClass('selected');
			_self.$scopeMob.find('#mob-in-flight-menu--container').hide();
			_self.$scopeMob.find('.book-opt-mhupgrade').parent().addClass('selected');
		});

		mobbookOptNFSTab.click(function () {
			_self.$scopeMob.find('.mob-view-booking--containertab').hide();
			_self.$scopeMob.find('.mob-mh-upgrade--containertab').show();
			_self.$scopeMob.find('#mob-mhupgrade--container').hide();
			_self.$scopeMob.find('#mob-nfs--container').show();
			_self.$scopeMob.find('#mob-stay--źontainer').hide();
			_self.$scopeMob.css('padding-bottom', '20px');
			_self.$scopeMob.find('.checkin-list li').removeClass('selected');
			_self.$scopeMob.find('.book-opt-nfs').parent().addClass('selected');
			_self.$scopeMob.find('#mob-in-flight-menu--container').hide();
		});
	}
}

let scope:Element = document.querySelector('#view-booking--container');
if (scope){
	try {
		let viewbookingform = new viewBookingForm();
		var adobeDataLayer = new adobeDataLayerWrapper();
		viewbookingform.nav();
		viewbookingform.init();
		viewbookingform.viewbookingForm();
		viewbookingform.deeplink();
	} catch(e) {console.error(e);}
}